var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { elementOpen, elementClose, elementVoid, text, patch } from 'incremental-dom';
import { Observable, from } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { completeCallback } from './utils';
var moduleList = []; // Keep a list of all modules which have been loaded
export var modulePage = function (pageChangeObservable, name, modname, loader, options) {
    var safeOptions = __assign({ loaderOptions: { delay: 0 } }, options); // Ensures safeOptions will always contain loaderOptions.delay;
    var loaderOptions = safeOptions.loaderOptions, moduleOptions = __rest(safeOptions, ["loaderOptions"]); // The rest of the options are passed to the module.
    var wrapperId = loaderOptions.class
        ? ['id', name + "-content", 'class', loaderOptions.class]
        : ['id', name + "-content"];
    if (moduleList[modname]) { // If we have already loaded this module just use it
        elementOpen('div', modname + "-" + name + "-content", wrapperId);
        {
            moduleList[modname][name](moduleOptions);
        }
        completeCallback(name);
        elementClose('div');
    }
    else {
        var mainContainer_1 = elementVoid('div', modname + "-" + name + "-content", wrapperId);
        // Create an observable which will emit either a loading placeholder or the module contents
        // If the module is not already loading it will trigger the dynamic load
        // If the actual module is emitted it will complete the subscriber
        var loaderSub_1;
        Observable.create(function (sub) {
            if (!loaderSub_1) { // If we have not already triggered the loader function
                setTimeout(function (_) {
                    loaderSub_1 = from(loader());
                    loaderSub_1.subscribe({
                        next: function (module) {
                            moduleList[modname] = module.moduleContent;
                            sub.next({ placeholder: false, content: moduleList[modname][name] });
                            sub.complete();
                        },
                    });
                }, loaderOptions.delay);
            }
            // The subscriber uses debounceTime so if the loader completes before 200ms this will never show
            if (loaderOptions.placeholder) {
                sub.next({ placeholder: true, content: loaderOptions.placeholder });
            }
            else {
                sub.next({ placeholder: true, content: function () { return text('Loading...'); } });
            }
        })
            .pipe(takeUntil(pageChangeObservable), // Cancel if the page is changed
        debounceTime(200))
            .subscribe({
            next: function (_a) {
                var placeholder = _a.placeholder, content = _a.content;
                // NICE: Make the loaded content fade in
                patch(mainContainer_1, function () { return content(moduleOptions); });
                if (!placeholder) {
                    completeCallback(name);
                }
            },
        });
    }
};
//# sourceMappingURL=dynamic.js.map